import { Chip, SxProps, useTheme } from '@mui/material'

export function UnseenChip({
  color = 'success500',
  label = '',
  sx,
}: {
  color?:
    | 'success'
    | 'neutral500'
    | 'neutral900'
    | 'neutral200'
    | 'neutral800'
    | 'neutral000'
    | 'success500'
  label?: string
  sx?: SxProps
}) {
  const theme = useTheme()
  return (
    <Chip
      sx={{
        backgroundColor: color,
        color:
          color === 'neutral200'
            ? 'neutral900'
            : color === 'neutral000'
            ? 'neutral700'
            : 'neutral000',
        height: '20px',
        minWidth: '20px',
        padding: '0 4px',
        ...theme.typography.caption1,
        '.MuiChip-label': {
          padding: 0,
        },
        ...sx,
      }}
      label={label}
    />
  )
}
